module.exports = {"TXTWCL_Deposit":{"id":"TXTWCL_Deposit","defaultMessage":"Insättning","track":"Deposit"}}